import moment from 'moment';

export const formatDateWithEstTimezone = (date) => (
  `${moment(date).tz('America/New_York').format('MM/DD/YYYY hh:mm A')} EST`
);

export const formatScheduleDate = (date, timezone) => (
  `${moment(date).tz(timezone).format('MMMM DD [at] h:mm A (HH:mm)')}`
);
